module.exports = __webpack_public_path__ + "static/media/clint-mckoy.9f17b8f6.jpg";